import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { detectOem, type OemConfig } from '@/data/oem-whitelist'
import { storage } from '@/api/preferences'
import { track } from '@/api/posthog'

const FLAG_KEY = 'pavemi_oem_whitelist_status'

export type OemStatus = 'unknown' | 'prompted' | 'accepted' | 'declined'

export async function detectProblematicOem(): Promise<OemConfig | null> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') return null
  try {
    const info = await Device.getInfo()
    return detectOem(info.manufacturer)
  } catch (_) {
    return null
  }
}

export async function getOemStatus(): Promise<OemStatus> {
  const v = await storage.get(FLAG_KEY)
  if (v === 'prompted' || v === 'accepted' || v === 'declined') return v
  return 'unknown'
}

export async function setOemStatus(s: OemStatus): Promise<void> {
  await storage.set(FLAG_KEY, s)
  track(`oem_whitelist_${s}`)
}
